module.exports = __webpack_public_path__ + "static/media/FM.1d9aff75.svg";